import { render, staticRenderFns } from "./_base-form-modal.vue?vue&type=template&id=61c4030d&"
import script from "./_base-form-modal.vue?vue&type=script&lang=js&"
export * from "./_base-form-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports